import { createKeys, featureKeys } from "Utilities/ReactQuery/fnKeys";

const HOME_SETTINGS_KEY = "homeSettings";
const MY_NOTES_KEY = "myNotes";

export const memberPortalKeys = createKeys(
  featureKeys.MEMBER_PORTAL_FEATURE_KEY,
  {
    homeSettings: () => [HOME_SETTINGS_KEY],
    myNotes: (searchTerm = "") => {
      // Don't create keys for invalid search terms (where length is > 0 or < 3)
      const isValidSearchTerm = !searchTerm || searchTerm.length > 2;
      return [MY_NOTES_KEY, isValidSearchTerm ? searchTerm : null];
    },
  }
);
